import { ACTION, type AssessmentGridAction } from "@/components/assessment-grid/constants";
import Button from "@/components/common/input/button";
import Modal from "@/components/common/modal";
import CompetencyBrowser from "@/components/competency-browser";
import AssessmentStepForm from "@/components/forms/assessment-step";

interface AdminControlsProps {
  edit_mode: boolean;
  dispatch: React.Dispatch<AssessmentGridAction>;
  onAddCompetency: (selected: string[]) => void;
  onAddStep: (title: string) => void;
}

export function AdminControls({
  edit_mode,
  dispatch,
  onAddCompetency,
  onAddStep,
}: AdminControlsProps) {
  return (
    <div className="mx-auto max-w-[60rem] py-4">
      <div className="flex items-center justify-end gap-4">
        {edit_mode && (
          <>
            <Modal>
              <Button>Add competency</Button>
              <CompetencyBrowser callbackFn={onAddCompetency} />
            </Modal>
            <Modal>
              <Button>Add assessment step</Button>
              <AssessmentStepForm callbackFn={onAddStep} />
            </Modal>
          </>
        )}
        <Button primary onClick={() => dispatch({ type: ACTION.toggle_edit })}>
          {edit_mode ? "Stop editing" : "Edit"}
        </Button>
      </div>
    </div>
  );
}
